//cspell:disable
import React, { useState } from "react";
import axios from "axios";
import Useletter from "../Useletter";
import Foter from "../Foter";
import { useNavigate } from "react-router-dom";

function Create() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    alternateEmail: "",
    dateOfBirth: "",
    maritalStatus: "",
    mobileNumber: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCreateAccount = async () => {
    const { firstName, lastName, email, password, confirmPassword, mobileNumber } =
      formData;

    if (!firstName || !lastName || !email || !password || !confirmPassword || !mobileNumber) {
      alert("All fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    try {
      const response = await axios.post("http://localhost:4000/api/create", formData);
      if (response.status === 201) {
        alert("Account created successfully!");
        navigate("/forgot");
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error creating account:", error.response?.data || error.message);
      alert(
        error.response?.data?.message ||
          "An error occurred while creating the account."
      );
    }
  };

  return (
    <div className="container-fluid" style={{ padding: "0 15px" }}>
      <br />
      <h3
        style={{
          textAlign: "left",
          fontFamily: "Alata,sans serif",
          fontSize: "20px",
          color: "#303030",
        }}
      >
        <span>CREATE NEW CUSTOMER ACCOUNT</span>
      </h3>
      <br />
      <div
        className="field note"
        style={{
          textAlign: "left",
          fontFamily: "Alata,sans serif",
          fontSize: "22px",
        }}
      >
        Personal Information
      </div>
      <hr style={{ maxWidth: "400px" }} />

      {/* First Name */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="firstName"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
                      textAlign: "left",

          }}
        >
          First Name
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
        />
      </div>

      {/* Last Name */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="lastName"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",   
                   textAlign: "left",

          }}
        >
          Last Name
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type="text"
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
        />
      </div>

      {/* Alternate Email */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="alternateEmail"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
                    textAlign: "left",
          }}
        >
          Alternate Email
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type="text"
          name="alternateEmail"
          value={formData.alternateEmail}
          onChange={handleInputChange}
        />
      </div>

      {/* Date of Birth */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="dateOfBirth"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
            textAlign: "left",
          }}
        >
          Date Of Birth
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type="date"
          name="dateOfBirth"
          value={formData.dateOfBirth}
          onChange={handleInputChange}
        />
      </div>

      {/* Marital Status */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="maritalStatus"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
            textAlign: "left",
          }}
        >
          Marital Status
        </label>
        <select
          className="form-select"
          style={{ maxWidth: "500px" }}
          name="maritalStatus"
          value={formData.maritalStatus}
          onChange={handleInputChange}
        >
          <option value="" disabled>
            Select
          </option>
          <option value="Married">Married</option>
          <option value="Single">Single</option>
        </select>
      </div>

      {/* Email */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="email"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
            textAlign: "left",
          }}
        >
          Email
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
        />
      </div>

      {/* Password */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="password"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
            textAlign: "left",
          }}
        >
          Password
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type={showPassword ? "text" : "password"}
          name="password"
          value={formData.password}
          onChange={handleInputChange}
        />
      </div>

      {/* Confirm Password */}
      <div className="mb-3">
        <label
          className="label"
          htmlFor="confirmPassword"
          style={{
            display: "block",
            fontWeight: "bold",
            fontFamily: "Alata,sans serif",
            fontSize: "14px",
            textAlign: "left",
          }}
        >
          Confirm Password
        </label>
        <input
          className="form-control"
          style={{ maxWidth: "500px" }}
          type={showPassword ? "text" : "password"}
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleInputChange}
        />
      </div>

      {/* Show Password */}
      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          onChange={() => setShowPassword(!showPassword)}
          id="showPassword"
          style={{ cursor: "pointer" }}
        />
        <label
          className="form-check-label"
          htmlFor="showPassword"
          style={{ fontFamily: "Alata,sans serif", fontSize: "14px",         
             textAlign: "left",
             display: "block",
          }}
        >
          Show Password
        </label>
      </div>

      {/* Mobile Number */}
      <div className="mb-3">
        <input
          className="form-control"
          style={{ maxWidth: "300px" }}
          type="text"
          name="mobileNumber"
          placeholder="Mobile Number"
          value={formData.mobileNumber}
          onChange={handleInputChange}
        />
      </div>

      {/* Submit Button */}
      <div style={{ textAlign: "left", marginBottom: "30px" }}>
        <button
          className="btn btn-dark"
          style={{ fontSize: "12px", fontFamily: "Alata,sans serif" }}
          onClick={handleCreateAccount}
        >
          CREATE AN ACCOUNT
        </button>
      </div>

      <Useletter />
      <Foter />
    </div>
  );
}

export default Create;
